import axios from 'axios';
import APIS from '../../apis/datura';
import {
  callbackHandler,
} from '../callbackHandler';

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getCommitAnswers(context, params) {
      return axios.post(APIS.daturaCommitAnswers, params)
        .then(function (res) {
          callbackHandler(APIS.daturaCommitAnswers, res);
          return res.data;
        })
    },
    getDaturaReport(context, params){
      return axios.get(APIS.daturaReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.daturaReport, res);
        return res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/datura.js